import { SubParticipantPosition } from '@collector/sportsapi-client-legacy'
import { SubParticipant } from '@collector/sportsapi-types'

import { PlayersConfig } from '../../configuration'

// config
function isPlayer(subParticipant: SubParticipant): boolean {
  return [
    SubParticipantPosition.StartingLineup,
    SubParticipantPosition.Player,
  ].includes(subParticipant.position)
}

export const playersConfig: PlayersConfig = {
  isPlayer,
}
